import { render, staticRenderFns } from "./SpeechesList.vue?vue&type=template&id=111b41ea&scoped=true&"
import script from "./SpeechesList.vue?vue&type=script&lang=js&"
export * from "./SpeechesList.vue?vue&type=script&lang=js&"
import style0 from "./SpeechesList.vue?vue&type=style&index=0&id=111b41ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111b41ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VList,VSkeletonLoader})
